import React from 'react'
import { Route } from 'react-router-dom'
import { IonApp, IonRouterOutlet } from '@ionic/react'
import { IonReactRouter } from '@ionic/react-router'
import Home from './pages/Home'

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css'

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css'
import '@ionic/react/css/structure.css'
import '@ionic/react/css/typography.css'

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css'
import '@ionic/react/css/float-elements.css'
import '@ionic/react/css/text-alignment.css'
import '@ionic/react/css/text-transformation.css'
import '@ionic/react/css/flex-utils.css'
import '@ionic/react/css/display.css'

/* Theme variables */
import './theme/variables.css'

const App: React.FC = () => {
  const isDark = localStorage.getItem('theme') === 'dark'

  if (isDark) {
    document.body.classList.add('dark')
  } else {
    document.body.classList.remove('dark')
  }

  // Set initial iOS status bar color
  const metaThemeColor = document.querySelector('meta[name="theme-color"]')
  const metaAppleStatusBar = document.querySelector('meta[name="apple-mobile-web-app-status-bar-style"]')
  if (isDark) {
    if (metaThemeColor) metaThemeColor.setAttribute('content', '#000000')
    if (metaAppleStatusBar) metaAppleStatusBar.setAttribute('content', 'black-translucent')
  } else {
    if (metaThemeColor) metaThemeColor.setAttribute('content', '#ffffff')
    if (metaAppleStatusBar) metaAppleStatusBar.setAttribute('content', 'default')
  }

  return (
    <IonApp>
      <IonReactRouter basename={process.env.PUBLIC_URL}>
        <IonRouterOutlet>
          <Route path="/" component={Home} exact={true} />
        </IonRouterOutlet>
      </IonReactRouter>
    </IonApp>
  )
}

export default App
